import { gsap } from "gsap";
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

export default {
	name: 'default',
	beforeLeave({ current, next, trigger }) {
		return new Promise(resolve => {

			document.dispatchEvent(new CustomEvent('disable-scroll'));

			gsap.to(current.container, {
				opacity: 0,
				ease: 'none',
				duration: 0.3,
				onComplete: () => {

					const color = next.container.dataset.color;
					const background = next.container.dataset.background;
					gsap.to(document.documentElement, {
						"--color": color,
						"--background": background,

						duration: 0.3,
						ease: 'none',
						onComplete: () => {
							resolve();
						}
					});
					//resolve();
				},
			});

			if(next.namespace!='template-features'&&next.namespace!='template-work') {
				document.dispatchEvent(new CustomEvent('hide-switcher'));
			}

			if(next.namespace==='single-project') {
				document.dispatchEvent(new CustomEvent('hide-menu'));
			}

		});
	},
	leave({ current, next, trigger }) {
		return new Promise(resolve => {

			gsap.set(next.container, {
				opacity: 0,
			});

			gsap.set(current.container, {
				position: 'absolute',
				top: 0,
				left: 0,
				width: current.container.getBoundingClientRect().width,
				zIndex: -10,
			});

			resolve();

		});
	},
	afterLeave({ current, next, trigger }) {
		return new Promise(resolve => {

			let switchDuration = 0;
			if(current.namespace==='template-features'||current.namespace==='template-work') {
				switchDuration = 1.4;
			}

			document.dispatchEvent(new CustomEvent('update-switcher', {
				detail: {
					namespace: next.namespace,
					duration: switchDuration
			  	}
			}));

			window.scrollTo(0, -1);
			setTimeout(() => {
				document.dispatchEvent(new CustomEvent('enable-scroll'));
				window.scrollTo(0, -1);
				resolve();
			}, 0);

		});
	},

	after({ current, next, trigger }) {
		return new Promise(resolve => {

			window.scrollTo(0, -1);

			gsap.to(next.container, {
				opacity: 1,
				ease: 'none',
				duration: 0.6,
				onComplete: () => {
					resolve();
				},
			});

			if(next.namespace==='template-features'||next.namespace==='template-work') {
				document.dispatchEvent(new CustomEvent('show-switcher'));
			}

			if(next.namespace!='single-project') {
				document.dispatchEvent(new CustomEvent('show-menu'));
			}

		});
	},
};
